import { takeLatest, call, put, select } from 'redux-saga/effects'
import * as actions from './actions'
import { startLoading, stopLoading, enqueueSnackbar } from '../root/actions'
import axios from 'axios'
import { getSagasMsgs } from '../root/selectors'

export const watchNetworkDevicesSaga = [
    takeLatest(actions.NETWORK_DEVICE_REQUEST, requestNetworkDevice),
    takeLatest(actions.UPDATE_NETWORK_DEVICE_REQUEST, updateNetworkDevice)
]

function* requestNetworkDevice(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        yield put(startLoading())
        const response = yield call(fetchNetworkDevice, action.networkDeviceId)
        yield put(actions.networkDeviceRequestSuccess(response))
        yield put(stopLoading())
    } catch (ex) {
        yield put(actions.networkDeviceRequestError())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.getDeviceEx,
                options: {
                    variant: 'error'
                }
            })
        )
        yield put(stopLoading())
    }
}

async function fetchNetworkDevice(networkDeviceId) {
    const response = await axios.get(
        `${process.env.API_URL}/routers/${networkDeviceId}`
    )
    return response.data
}

function* updateNetworkDevice(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        yield put(startLoading())
        yield call(
            patchNetworkDeviceRequest,
            action.networkDeviceId,
            action.body
        )
        yield put(actions.updateNetworkDeviceSuccess())
        const response = yield call(fetchNetworkDevice, action.networkDeviceId)
        yield put(actions.networkDeviceRequestSuccess(response))
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.updateDeviceRes,
                options: {
                    variant: 'success'
                }
            })
        )
        yield put(stopLoading())
    } catch (ex) {
        yield put(actions.updateNetworkDeviceError())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.updateDeviceEx,
                options: {
                    variant: 'error'
                }
            })
        )
        yield put(stopLoading())
    }
}

async function patchNetworkDeviceRequest(networkDeviceId, body) {
    await axios.patch(`${process.env.API_URL}/routers/${networkDeviceId}`, body)
}
